<script lang="ts">
  // 1 · Welcome: what Timepeak does for you.
  import { Repeat, Users, Download } from '@lucide/svelte';
  import { t } from '../../i18n.svelte';
  import { session } from '../../stores/session.svelte';
  import StepIntro from './StepIntro.svelte';

  const firstName = $derived((session.user?.name || '').trim().split(/\s+/)[0] || '');
  const points = [
    { icon: Repeat, key: 'onb.welcome.p1' },
    { icon: Users, key: 'onb.welcome.p2' },
    { icon: Download, key: 'onb.welcome.p3' }
  ];
</script>

<StepIntro kicker={t('onb.welcome.kicker', { name: firstName ? `, ${firstName}` : '' })} title={t('onb.welcome.title')} lead={t('onb.welcome.text')} />
<ul class="points">
  {#each points as point, i (point.key)}
    <li style:animation-delay="{i * 80}ms">
      <span class="icon"><point.icon size={16} /></span>{t(point.key)}
    </li>
  {/each}
</ul>

<style>
  .points { list-style: none; margin: var(--space-2) 0 0; padding: 0; display: flex; flex-direction: column; gap: var(--space-3); }
  .points li { display: flex; align-items: center; gap: var(--space-3); font-size: var(--text-md); animation: rise-in 360ms var(--ease) both; }
  .icon { display: grid; place-items: center; flex-shrink: 0; width: var(--control-h-sm); height: var(--control-h-sm); border-radius: var(--radius-sm); background: var(--brand-soft); color: var(--brand); }
</style>
